export const filterPaymentTypes = () => {
  const paymentTypes = ['Merit lump-sum off-cycle', 'Merit lump-sum off-cycle NET']
  return paymentTypes
}
